import { render, staticRenderFns } from "./document-appendices.vue?vue&type=template&id=8e5fd562&scoped=true&"
import script from "./document-appendices.vue?vue&type=script&lang=js&"
export * from "./document-appendices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5fd562",
  null
  
)

export default component.exports